export class StoreSearchData {
  constructor(coordinates, productData) {
    this.latitude = coordinates.getLatitude();
    this.longitude = coordinates.getLongitude();
    if ((productData === null || productData === void 0 ? void 0 : productData.product_ref) || productData) {
      this.productRef = (productData === null || productData === void 0 ? void 0 : productData.product_ref) || productData;
    }
  }
  getProductRef() {
    return this.productRef || '';
  }
}